// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MaterialTable .first{border-top:1px solid #000}`, "",{"version":3,"sources":["webpack://./src/Quote/Materials/Material.scss"],"names":[],"mappings":"AAEE,sBACE,yBAAA","sourcesContent":[".MaterialTable {\n\n  .first{\n    border-top:1px solid black;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
